import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="md" sx={{ textAlign: 'center', mt: 8 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h1" sx={{ fontSize: '6rem', fontWeight: 'bold', color: 'error.main' }}>
          404
        </Typography>

        <Typography variant="h4" sx={{ mt: 2, mb: 3 }}>
          Oops! Page Not Found
        </Typography>

        <Typography variant="body1" sx={{ mb: 4 }}>
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={()=>navigate('/dashboard')}
        >
          Go to Home Page
        </Button>
      </Box>
    </Container>
  );
};

export default PageNotFound;